import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const ArrowPathClockwiseOutlinedSize24Component = (props, ref) => (jsx("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("g", { children: jsx("path", { d: "M18 5.89991L13.1002 1L11.8275 2.27279L14.5545 5H12C5.25 5 3 9.5 3 14C3 18.5 5.25 23 12 23C18.75 23 21 18.5 21 14H19.2C19.2 15.9826 18.7009 17.7723 17.6485 19.0352C16.6442 20.2403 14.9421 21.2 12 21.2C9.05787 21.2 7.35584 20.2403 6.35155 19.0352C5.29913 17.7723 4.8 15.9826 4.8 14C4.8 12.0174 5.29913 10.2277 6.35155 8.96483C7.35584 7.75968 9.05787 6.8 12 6.8L14.5543 6.80003L11.8273 9.52687L13.1001 10.7997L18 5.89991Z", fill: "var(--magritte-ui-icon-color)" }) }) }));
const ArrowPathClockwiseOutlinedSize24 = hoc(forwardRef(ArrowPathClockwiseOutlinedSize24Component), 'ArrowPathClockwiseOutlinedSize24');

export { ArrowPathClockwiseOutlinedSize24 as default };
//# sourceMappingURL=ArrowPathClockwiseOutlinedSize24.js.map
